import { IMedia } from "api/types/_media";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string;
}
interface DropdownMediaProps {
  name?: string,
  typeValue?: string,
  dataList?: IMedia[],
  initialValue?: Option | Option[] | null;
  onChangeSelect?: (params: Option) => void;
  placeholder?: string,
  isMulti?: boolean,
  isFullKey?: boolean
}
const DropdownMedia = ({
  name = '',
  typeValue = 'id',
  initialValue,
  dataList = [],
  onChangeSelect,
  placeholder,
  isMulti = false,
  isFullKey = false
}: DropdownMediaProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    const result = dataList?.map((item: any) => ({ ...(isFullKey ? item : {}), label: `${item?.name} ${!!item?.add_type ? ` | ${t(`MEDIA_TYPE_${item?.add_type}`)}` : ''}`, value: String(item[typeValue]) })) || [] as Option[];
    setOptions((_prev: any) => result);
  }, [JSON.stringify(dataList), typeValue]);

  return (
    <React.Fragment>
      <Select
        cacheOptions
        options={options}
        closeMenuOnSelect={true}
        name={name}
        value={initialValue}
        isMulti={isMulti}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder ? placeholder : t('Select Medias')}...</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        formatOptionLabel={(option: any) => (<div className="d-flex">{option?.label}</div>)}
        className="search-filter-media dropdown-status-rounded"
        classNamePrefix="name-prefix"
      />
    </React.Fragment>
  );
};

export default DropdownMedia;
